import React from 'react';
const TimerContext = React.createContext<any>({
    updateRunningTimers: () => {},
});
export default TimerContext;
